// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.RentalManagerUserPropertyGetFieldsWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { ListingAlias, UserPropertyGetFieldsRequestDto, UserPropertyGetFieldsResponseWebDto } from '../..';

interface GetPropertyFieldsParams {
  listingAlias: ListingAlias;
}

export const RentalManagerUserPropertyGetFieldsWebApiHandler_getPropertyFields_Path =
  '/api/web/v1/users/properties/getPropertyFields';

/**
 * Infer rental property listing fields for an existing manual listing
 * @deprecated
 */
export const RentalManagerUserPropertyGetFieldsWebApiHandler_getPropertyFields = (
  getParams: GetPropertyFieldsParams,
  postData: UserPropertyGetFieldsRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    GetPropertyFieldsParams,
    UserPropertyGetFieldsRequestDto,
    UserPropertyGetFieldsResponseWebDto
  >(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyGetFieldsWebApiHandler_getPropertyFields_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};
